import type { LegalMentionsSettings } from '../../../types/legalSettings/legalMentionsSettings'
import type { ComplianceSettingsFormValues } from '../types/complianceSettingsFormValues'

// LegalMentionsModal validates the full `custom` object, including `vatExemptionScheme`, which this
// module does not own. Null passes its schema; only the edited key is read back on submit.
export const getLegalMentionsModalDefaultValues = (
  legalMentions: ComplianceSettingsFormValues['legalMentions'],
): LegalMentionsSettings => ({
  custom: {
    ...legalMentions.custom,
    vatExemptionScheme: null,
  },
})
